var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoubleLeftArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 24,
    viewBox: "0 0 16 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7608 17.7679C15.0797 17.4584 15.0797 16.9567 14.7608 16.6472L9.97161 12L14.7608 7.3528C15.0797 7.04333 15.0797 6.54158 14.7608 6.2321C14.4419 5.92263 13.9248 5.92263 13.6059 6.2321L8.2392 11.4397C7.92027 11.7491 7.92027 12.2509 8.2392 12.5603L13.6059 17.7679C13.9248 18.0774 14.4419 18.0774 14.7608 17.7679Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.7608 17.7679C8.07973 17.4584 8.07973 16.9567 7.7608 16.6472L2.97161 12L7.7608 7.3528C8.07973 7.04333 8.07973 6.54158 7.7608 6.2321C7.44188 5.92263 6.92479 5.92263 6.60586 6.2321L1.2392 11.4397C0.920269 11.7491 0.920268 12.2509 1.2392 12.5603L6.60586 17.7679C6.92479 18.0774 7.44187 18.0774 7.7608 17.7679Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleLeftArrow);
export default __webpack_public_path__ + "static/media/DoubleLeftArrow.fbfe940c662cb8b225079e2d3e15d5b3.svg";
export { ForwardRef as ReactComponent };